/* This file is intended as a one stop shop of graphical artifacts
used throughout the site, including illustrations, icons and logos.
New graphical assets should be added here. */

export const Images = {
    desktop: {
        comparison: require('../images/Illustrations/comparison.svg'),           
        nutrition: require('../images/Illustrations/nutrition.svg'),            
        opportunity: require('../images/Illustrations/opportunity.svg'),
        propagation:  require('../images/Illustrations/propagation.svg'),            
        productionI:  require('../images/Illustrations/productionI.svg'),            
        productionS:  require('../images/Illustrations/productionS.svg'),            
        agroforestry: require('../images/Illustrations/agroforestry.svg'),            
        mulching: require('../images/Illustrations/mulching.svg'),            
        caterpillar: require('../images/Illustrations/caterpillar.svg'),        
        termite: require('../images/Illustrations/termite.png'),    
        fungi: require('../images/Illustrations/fungi.svg'),
        labeling: require('../images/Illustrations/labeling.svg'),            
        packaging: require('../images/Illustrations/packaging.svg'),            
        hygiene: require('../images/Illustrations/hygiene.svg'),            
        drying: require('../images/Illustrations/drying.svg'),            
        draining: require('../images/Illustrations/draining.svg'),            
        petiole: require('../images/Illustrations/petiole.svg'),
        branch:  require('../images/Illustrations/branch.svg'),                    
    },
    mobile: {
        comparison: require('../images/Illustrations/comparison-mobile.svg'),        
        nutrition: require('../images/Illustrations/nutrition-mobile.svg'),        
        opportunity: require('../images/Illustrations/opportunity-mobile.svg'),
        propagation: require('../images/Illustrations/propagation-mobile.svg'),        
        productionI: require('../images/Illustrations/productionI-mobile.svg'),       
        productionS: require('../images/Illustrations/productionS-mobile.svg'),        
        agroforestry: require('../images/Illustrations/agroforestry-mobile.svg'),        
        mulching: require('../images/Illustrations/mulching-mobile.svg'),       
        caterpillar: require('../images/Illustrations/caterpillar-mobile.svg'),        
        fungi: require('../images/Illustrations/fungi-mobile.svg'),
        labeling: require('../images/Illustrations/labeling-mobile.svg'),       
        packaging: require('../images/Illustrations/packaging-mobile.svg'),        
        hygiene: require('../images/Illustrations/hygiene-mobile.svg'),       
        drying:  require('../images/Illustrations/drying-mobile.svg'),        
        draining: require('../images/Illustrations/draining-mobile.svg'),        
        petiole: require('../images/Illustrations/petiole-mobile.svg'),
        branch: require('../images/Illustrations/branch-mobile.svg'),        
    }
};

export const Icons = {
    cultivation: require('../images/icons/cultivation-icon-70px.svg'),
    site: require('../images/icons/site-selection-icon-70px.svg'),
    soil: require('../images/icons/soil-preparation-icon-70px.svg'),
    propagation: require('../images/icons/propagation-icon-70px.svg'),
    planting: require('../images/icons/planting-icon-70px.svg'),
    care: require('../images/icons/plant-care-icon-70px.svg'),
    pests: require('../images/icons/insects-and-fungi-icon-70px.svg'),
    registration: require('../images/icons/registration.svg'),
    verification: require('../images/icons/verification.svg'),
    payment: require('../images/icons/payment.svg'),
    inspection: require('../images/icons/inspection.svg'),
    authorization: require('../images/icons/authorization.svg'),
    certification: require('../images/icons/certification.svg'),
    maintenance: require('../images/icons/maintenance.svg'),
    learn: require('../images/icons/learn-icon-70px.svg'),
    invest: require('../images/icons/invest-icon-70px.svg') 
};

export const Logos = {
    CarbonGreen: require('../images/logos/carbon-green.svg'),
    SustainTnT: require('../images/logos/sustain-T-T.svg'),
    TheResilienceFund: require('../images/logos/the-resilience-fund.svg')
}
